import React, { useEffect, useState } from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const HelpShurui = props => {
  return <Dropdown.Static kubunKey='help_shurui' {...props} />
}
